// extracted by mini-css-extract-plugin
export default {"menu--btn-big":"MenuButtonBig_menu--btn-big__BfuYO"};